export function fullYearFromLastTwoDigitsInCurrentCentury(lastTwoDigits: number): number {
    const currentYear = new Date().getFullYear();
    const currentCentury = Math.floor(currentYear / 100) * 100; // Gets the current century, e.g., 2000

    return currentCentury + lastTwoDigits; // Same century as the current year
}